import { API_HOST, getHttpGetOptions, getHttpPostOptions, getHttpPutOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/programme`;
const getSpecificEndpoint = (externalReference) => `${getEndpoint()}/${externalReference}`;

export const getCreateProgrammeRequest = (programme) => [getEndpoint(), getHttpPostOptions(programme)];

export const getViewAllProgrammesRequest = () => [getEndpoint(), getHttpGetOptions()];

export const getViewProgrammeRequest = (externalReference) => [
  getSpecificEndpoint(externalReference),
  getHttpGetOptions()
];

export const getUpdateProgrammeRequest = (programme) => [getEndpoint(), getHttpPutOptions(programme)];

const getActivateEndpoint = (externalReference) => `${getEndpoint()}/activate/${externalReference}`;
export const getActivateProgrammeRequest = (externalReference) => [
  getActivateEndpoint(externalReference),
  getHttpGetOptions()
];

const getViewUnassignedMembersEndpoint = (externalReference) =>
  `${getSpecificEndpoint(externalReference)}/members/unassigned-to-teams`;
export const getViewUnassignedMembersRequest = (externalReference) => [
  getViewUnassignedMembersEndpoint(externalReference),
  getHttpGetOptions()
];

const getDownloadTeamLeaderboardExcelEndpoint = () => `${getEndpoint()}/excel/download`;
export const getDownloadTeamLeaderboardExcelRequest = (data) => [
  getDownloadTeamLeaderboardExcelEndpoint(),
  getHttpPostOptions(data)
];

const getSendMemberActivationCommunicationsEndpoint = (programmeExternalReference, memberExternalReference) =>
  `${getSpecificEndpoint(
    programmeExternalReference
  )}/members/${memberExternalReference}/send-activation-communications`;
export const getSendMemberActivationCommunicationsRequest = (
  programmeExternalReference,
  memberExternalReference,
  sendSms,
  sendEmail
) => [
  getSendMemberActivationCommunicationsEndpoint(programmeExternalReference, memberExternalReference),
  getHttpPostOptions(undefined, undefined, { sendSms, sendEmail })
];

const getUploadMemberExcelEndpoint = (programmeExternalReference) =>
  `${getSpecificEndpoint(programmeExternalReference)}/members/upload`;
export const getUploadMemberExcelRequest = (programmeExternalReference, base64String) => [
  getUploadMemberExcelEndpoint(programmeExternalReference),
  getHttpPostOptions({ data: base64String })
];
